<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesError"
                           :error="error"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :title="'editionClient.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <section class="columns is-marginless is-multiline">
        <div class="has-text-centered column is-12 pdt-0">
          <b-icon type="is-primary" icon="information" class="icon-modal"></b-icon>
          <p class="has-text-centered ">
            {{ $t('detailTitreRecette.popUpAvoir.title') }}
          </p>
          <p class="has-text-centered has-text-weight-bold mgt-10px"
             v-if="titreRecette.etat == constantes.ETAT_PAYE">
            {{ $t('detailTitreRecette.popUpAvoir.annulerFacturePayer') }}
          </p>
          <p class="has-text-centered mgt-20px">
            {{ $t('detailTitreRecette.popUpAvoir.avoirMessage') }}
            <span class="has-text-weight-bold">{{ titreRecette.code }}</span>
            {{ $t('detailTitreRecette.popUpAvoir.finAvoirMessage') }}
          </p>
          <p class="has-text-centered mgt-20px is-size-7">
            {{ $t('detailTitreRecette.popUpAvoir.annulerConfirm') }}
              <span class="has-text-weight-bold"> {{ titreRecette.code }}</span>
            {{ $t('detailTitreRecette.popUpAvoir.finAnnulerConfirm') }}
          </p>
        </div>
        <div class="column is-12 pdt-0">
          <b-field :label="$t('detail.popup.dateAvoir')"
                   class="obligatoire"
                   :type="dateHasError">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          icon="calendar-today"
                          :editable="true"
                          v-model="dateAvoir">
            </b-datepicker>
          </b-field></div>
        <div class="column is-12 pdt-0">
          <b-field :label="$t('detail.popup.commentaire')">
            <b-input type="textarea"
                     :placeholder="$t('detail.popup.commentaireAvoir')"
                     v-model="commentaireAvoir">
            </b-input>
          </b-field>
        </div>
      </section>
      <footer>
        <div class="has-text-centered">
          <button class="button btn-modal-annuler is-primary  has-text-centered mg-button-modal"
                  @click="createAvoirPartiel">
            {{ $t('detail.popup.avoirPartiel') }}
          </button>
          <b-tooltip :label="$t('detailTitreRecette.popUpAvoir.error.totalementRapprochee')"
            :active="!peutAvoirTotal">
            <button class="button is-primary has-text-centered mg-button-modal"
                    @click="createAvoirTotal"
                    :class="{'disabled':
                          !peutAvoirTotal}">
              {{ $t('detail.popup.avoirTotal') }}
            </button>
          </b-tooltip>
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('detail.popup.annuler') }}
          </button>
        </div>
      </footer>
      <footer>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import genererAvoirFactureBailleur from '@/services/baux/factureAchatArapprocher/genererAvoirFactureBailleur';
import { avoirTotal } from '@/api/factureAchatARapprocher/index';
import formatDate from '@/services/general/formatIsoDate';
import * as devisConf from '@/configuration/devisConf';
import translate from '@/services/devisCommandes/validation/champsAvoirTranslator';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as types from '@/store/modules/facture-mutation-type';
import validationFacture from '@/services/devisCommandes/validation/validation';
import validationGeneral from '@/services/validation/validation';

const factures = createNamespacedHelpers('facture');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popUpAvoirTitreRecette',
  props: {
    titreRecette: {
      type: Object,
      required: true,
    },
    commandeAchatRapprocher: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: {},
      messagesError: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      dateAvoir: null,
      commentaireAvoir: '',
      impactAchatVenteInterne: true,
      constantes: {
        ETAT_PAYE: devisConf.ETAT_PAYE,
      },
    };
  },
  computed: {
    dateHasError() {
      return this.error && !this.dateAvoir ? 'is-danger' : '';
    },
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    peutAvoirTotal() {
      return this.commandeAchatRapprocher.length === 0;
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.dateAvoir = new Date();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
  methods: {
    ...factures.mapMutations({
      setAvoirACreer: types.SET_AVOIR_A_CREER,
    }),
    createAvoirPartiel() {
      const avoir = genererAvoirFactureBailleur(
        this.titreRecette,
        this.dateAvoir,
        this.commentaireAvoir,
      );
      this.setAvoirACreer(avoir);
      this.$router.push({ name: 'm.gabed.titre_recette-ajout' });
    },
    async createAvoirTotal() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await avoirTotal({
          id: this.titreRecette.id,
          dateAvoir: formatDate(this.dateAvoir),
          commentaireAvoir: this.commentaireAvoir,
          aRapprocher: true,
        });
        messageSucces(this.$t('detail.popup.creationAvoir'));
        this.$parent.close();
        this.$router.push({ name: 'c.gabed.titre_recette', params: { id: response.data.result.id } });
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messagesError = [];
          validationFacture(
            e.response,
            this.messagesError, this.titreRecette,
            devisConf.SOUS_TYPE_AVOIR,
          );
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesError, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>
